<script lang="ts">
	//UI
	import ImageTitleStatus from "./ImageTitleStatus.svelte";
	import StoreDescription from "./StoreDescription.svelte";
	import StoreAdditionalInfo from "./StoreAdditionalInfo.svelte";
	//Utils
	//Types
	//Props
	export let storeImageURL = "";
	export let editmode = true;
	export let formattedAddress1 = "";
	export let formattedAddress2 = "";
	export let lat = 0;
	export let lng = 0;
	export let phonenumber = "";
	export let phonenumberCountryCode = "";
	export let cacheReceiptAvailable = "";
	export let type1 = "";
	export let type2 = "";
	export let detailAddress = "";
	export let appLockEnabled = false;
	export let storeDescription = "";
	export let storename = "";
	export let storeStatus = "";
	export let smartpayAvailable = "";

	//Constants
	//Variables
	//Functions
	//Do
</script>

<div class="container" class:editmode={editmode}>
	<div class="image-title-status">
		<ImageTitleStatus
			bind:storename={storename}
			bind:storeStatus={storeStatus}
			bind:storeImageURL={storeImageURL}
			editmode={editmode}
		/>
	</div>
	<div class="description">
		<StoreDescription
			editmode={editmode}
			bind:storeDescription={storeDescription}
		/>
	</div>
	<div class="store-addtional-info">
		<StoreAdditionalInfo
			bind:formattedAddress1={formattedAddress1}
			bind:formattedAddress2={formattedAddress2}
			bind:lat={lat}
			bind:lng={lng}
			bind:phonenumber={phonenumber}
			bind:phonenumberCountryCode={phonenumberCountryCode}
			bind:cacheReceiptAvailable={cacheReceiptAvailable}
			bind:type1={type1}
			bind:type2={type2}
			bind:detailAddress={detailAddress}
			bind:appLockEnabled={appLockEnabled}
			bind:smartpayAvailable={smartpayAvailable}
			editmode={editmode}
		/>
	</div>
</div>

<style lang="scss">
	@import "../../../../variables.scss";
	.container {
		display: flex;
		flex-direction: column;
		gap: 20px;
	}

	@include DesktopSize {
		.container {
			gap: 30px;
			&:not(.editmode) {
				background-image: url("/img/common/counter.png");
				background-repeat: no-repeat;
				background-size: 110px 130.5px;
				background-position: bottom right;
			}
		}
	}
</style>
